export default function ContentTrust() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-4">
          <span className="inline-block text-xs tracking-[0.15em] text-foreground-500 px-3 py-1 border border-foreground-200 rounded-full">
            內容說明
          </span>
        </div>
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-800 text-center mb-2">
          出版內容與資訊說明
        </h2>
        <p className="text-xs text-foreground-500 text-center mb-10 md:mb-12 max-w-xl mx-auto leading-relaxed">
          以下說明有助於理解清文華泉出版內容的性質、範圍與資料來源。
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {/* AIGC 內容說明 */}
          <div className="p-5 rounded-xl bg-background-100/70 border border-background-200/60">
            <h3 className="text-sm font-semibold text-foreground-800 mb-2 flex items-center gap-2">
              <i className="ri-palette-line text-accent-500 text-base"></i>
              AIGC 彩色書籍
            </h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              AIGC 為部分出版內容的圖像或視覺呈現方式，不代表所有文字、圖片均完全由人工智慧生成，也不代表清文華泉提供對外 AI 生圖、AI 寫作、系統導入或出版代工服務。實際製作與使用方式以個別書籍正式資料為準。
            </p>
          </div>

          {/* 科普內容邊界 */}
          <div className="p-5 rounded-xl bg-background-100/70 border border-background-200/60">
            <h3 className="text-sm font-semibold text-foreground-800 mb-2 flex items-center gap-2">
              <i className="ri-microscope-line text-secondary-500 text-base"></i>
              科普類書籍
            </h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              網站所呈現的科普內容為出版與一般知識閱讀資訊，不能取代正式研究、專業教育、醫療診斷或其他專業意見。健康與醫療相關內容為一般知識資訊，不能取代醫師或其他合格專業人員的評估、診斷與建議。
            </p>
          </div>

          {/* 歷史內容邊界 */}
          <div className="p-5 rounded-xl bg-background-100/70 border border-background-200/60">
            <h3 className="text-sm font-semibold text-foreground-800 mb-2 flex items-center gap-2">
              <i className="ri-history-line text-primary-500 text-base"></i>
              歷史類書籍
            </h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              個別作品內容與作者觀點，不代表清文華泉或崧博出版的官方立場。書籍中的插畫、重製圖像或 AIGC 圖像以知識呈現與閱讀輔助為目的，不得視為真實歷史照片、原始史料或學術復原成果。
            </p>
          </div>

          {/* 圖像使用邊界 */}
          <div className="p-5 rounded-xl bg-background-100/70 border border-background-200/60">
            <h3 className="text-sm font-semibold text-foreground-800 mb-2 flex items-center gap-2">
              <i className="ri-image-line text-foreground-500 text-base"></i>
              圖像與視覺內容
            </h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              書籍中的圖像與視覺內容以知識呈現與閱讀輔助為目的，實際科學、歷史及其他專業資訊，以個別出版資料與可靠專業來源為準。圖像不得視為科學攝影、真實紀錄照片、歷史原始照片或學術研究證據。
            </p>
          </div>
        </div>

        <div className="mt-8 md:mt-10 max-w-4xl mx-auto">
          <div className="p-5 rounded-xl bg-background-100/70 border border-background-200/60 text-center">
            <h3 className="text-sm font-semibold text-foreground-800 mb-2 flex items-center justify-center gap-2">
              <i className="ri-book-open-line text-foreground-500 text-base"></i>
              書籍資料來源
            </h3>
            <p className="text-xs text-foreground-600 leading-relaxed max-w-2xl mx-auto mb-4">
              完整書名、作者、ISBN、內容主題、出版品牌及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。個別作者資格只屬於作者本人，不代表清文華泉具有科研、教育、醫療或歷史研究機構資格。
            </p>
            <a
              href="https://catalog.sonbook.net/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer underline underline-offset-2"
            >
              前往崧博書籍資料庫查詢完整書目
              <i className="ri-external-link-line text-[10px]"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}